import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DWSMUtils } from 'src/app/dwsm/dwsm-utils';
import { GraphData } from 'src/app/dwsm/models/GraphData';

@Component({
    selector: 'sera-line-chart',
    templateUrl: './sera-line-chart.component.html',
    styleUrls: ['./sera-line-chart.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraLineChartComponent implements OnInit {
    readonly LINE_CHART_OPTIONS = {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
            legend: {
                labels: false
            },
            tooltip: {
                enabled: false
            }
        },
        elements: {
            point: {
                radius: 0
            }
        },
        scales: {
            x: {
                display: true,
                grid: {
                    display: true
                }
            },
            y: {
                display: true,
                grid: {
                    display: true
                }
            }
        }
    };

    chartData: any;

    @Input()
    graphData?: GraphData;

    @Input()
    xAxisLabel: string = '';

    @Input()
    yAxisLabel: string = '';

    ngOnInit() {
        if (this.graphData) {
            this.chartData = {
                labels: this.graphData!.labels,
                datasets: this.buildDatasets()
            };
        }
    }

    buildDatasets() {
        return this.graphData!.data.map((data, i) => ({ data, i }))
            .filter(({ i }) => !this.graphData?.datasetOverride[i].hidden)
            .map(({ data, i }) => {
                const colorIndex = i % DWSMUtils.COLORS_ENABLED.length;
                return {
                    type: 'line',
                    borderColor: DWSMUtils.COLORS_ENABLED[colorIndex],
                    data: data,
                    fill: false
                };
            });
    }
}
